export default "__VITE_ASSET__BEAggfxW__"